import { findCategoryByText } from './category-utils';
//This is hard coded to get kgCO2e only

// Kept for its existing callers: resolves stored category text (a rule's categoryName, an import
// line) to a category by stored name, then display name, then the name it used to have. See
// category-utils, which holds the rule.
export function findCategoryByDisplayName<T extends { name: string; friendlyName?: string | null; legacyName?: string | null }>(
  categories: T[] | undefined,
  displayName: string,
): T | undefined {
  return findCategoryByText(categories, displayName);
}

export function buildCategoryFilterQueryString({
  calendarYear,
  groupId,
  defaultConversionSourceId,
  selectedData,
}: {
  calendarYear: string;
  groupId: string;
  defaultConversionSourceId: string;
  selectedData: Record<string, any>;
}): string {
  let queryString = `?calendarYear=${calendarYear}&groupId=${groupId}&conversionSourceId=${defaultConversionSourceId}&greenHouseGasUnitId=7ec07fb5-371e-4830-9068-ac4f65fd7f4c`;
  Object.entries(selectedData).forEach(([key, value]) => {
    if (value) {
      queryString += `&${key}=${encodeURIComponent(value as string)}`;
    }
  });
  return queryString;
}

